module.exports = __webpack_public_path__ + "static/media/Progress.0c26586a.svg";